import Vue from 'vue'
import Router from 'vue-router'
import hom from './hom'
import Repurchase from './repurchase'
// 谷歌 删除账号声明
import gp from './gp'
import NewDesign from './newDesign'

Vue.use(Router)

const PreviewContract = () => import('../views/contract/previewContract.vue')
const PdfContract = () => import('../views/contract/pdfContract.vue')
const Survey = () => import('../views/app/survey/survey.vue')
const NewSurvey = () => import('../views/app/survey/newSurvey.vue')

const router = new Router({
	routes: [
		...hom,
		...Repurchase,
		...gp,
    ...NewDesign,
		{
			path: '/app/invite',
			name: 'Invite',
			component: () => import('../views/app/invite/invite.vue'),
			meta: {
				'title': 'Coupons from okash'
			}
		},
		{
			path: '/app/invite/rule',
			name: 'Rule',
			component: () => import('../views/app/invite/rule.vue'),
			meta: {
				'title': 'Coupons from okash'
			}
		},
		{
			path: '/app/register',
			name: 'Register',
			component: () => import('../views/app/invite/register.vue'),
			meta: {
				'title': 'Coupons from okash'
			}
		},
		{
			path: '/app/download',
			name: 'download',
			component: () => import('../views/app/recallApp/index.vue'),
			meta: {
				'title': 'OKash'
			}
		},
		// -------------- begin
		// privacy和terms已经不用，统一改到了官网下的html文件夹下的html页面
		{
			path: '/app/privacy',
			name: 'Privacy',
			component: () => import('../views/app/doc/privacy.vue'),
			meta: {
				'title': 'OKash'
			}
		},
		{
			path: '/app/terms',
			name: 'Terms',
			component: () => import('../views/app/doc/terms.vue'),
			meta: {
				'title': 'OKash'
			}
		},
		// -------------- end
		// 拒必赔规则
		{
			path: '/app/refuseToPay',
			name: 'refuseToPay',
			component: () => import('../views/app/doc/refuseToPay.vue'),
			meta: {
				'title': 'Rules'
			}
		},
		{
			path: '/app/guidelines',
			name: 'guidelines',
			component: () => import('../views/app/doc/guidelines.vue'),
			meta: {
				'title': 'Guidelines'
			}
		},
		{
			path: '/app/offline',
			name: 'offline',
			component: () => import('../views/app/offline/offline.vue'),
			meta: {
				'title': 'Guidelines'
			}
		},
		// ussd --- 用于老用户的过渡页面，判断分配到opay还是wema
		{
			path: '/app/ussd',
			name: 'USSD',
			component: () => import('../views/app/transfer/ussd/transferUssd.vue'),
			meta: {
				'title': 'USSD'
			}
		},
		{
			path: '/app/opayussd',
			name: 'USSD',
			component: () => import('../views/app/transfer/ussd/opayUssd.vue'),
			meta: {
				'title': 'USSD'
			}
		},
		{
			path: '/app/wemaussd',
			name: 'USSD',
			component: () => import('../views/app/transfer/ussd/wemaUssd.vue'),
			meta: {
				'title': 'USSD'
			}
		},
		{
			path: '/app/bank',
			name: 'Bank',
			component: () => import('../views/app/transfer/bank/transferBank.vue'),
			meta: {
				'title': 'Bank Transfer'
			}
		},
		{
			path: '/app/opaybank',
			name: 'Bank',
			component: () => import('../views/app/transfer/bank/opayBank.vue'),
			meta: {
				'title': 'Bank Transfer'
			}
		},
		{
			path: '/app/wemabank',
			name: 'Bank',
			component: () => import('../views/app/transfer/bank/wemaBank.vue'),
			meta: {
				'title': 'Bank Transfer'
			}
		},
		// contract - preview
		{
			path: '/previewContract',
			name: 'previewContract',
			component: PreviewContract,
			meta: {
				title: 'OKash Loan'
			}
		},
		// contract ---- pdfContract
		{
			path: '/pdfContract',
			name: 'pdfContract',
			component: PdfContract,
			meta: {
				title: 'OKash Loan'
			}
		},
		// survey --- survey
		{
			path: '/survey',
			name: 'survey',
			component: Survey,
			meta: {
				title: 'OKash User Survey'
			}
		},
    // survey --- 新版survey页
		{
			path: '/newsurvey',
			name: 'newsurvey',
			component: NewSurvey,
			meta: {
				title: 'OKash User Survey'
			}
		},
		{
			path: '/info',
			name: 'info',
			component: () => import('../views/app/basic/info.vue'),
			meta: {
				title: 'Basic Information'
			}
		},
		{
			path: '/contact',
			name: 'contact',
			component: () => import('../views/app/basic/contact.vue'),
			meta: {
				title: 'Emergency contact'
			}
		},
		{
			path: '/app/repayment',
			name: 'repayment',
			component: () => import('../views/app/repayment/index.vue'),
			meta: {
				'title': 'OKash Active Loans'
			}
		},
		{
			path: '/app/loan-history',
			name: 'loanHistory',
			component: () => import('../views/app/repayment/loan-history.vue'),
			meta: {
				'title': 'Repayment History'
			}
		},
		{
			path: '/app/plan',
			name: 'repaymentPlan',
			component: () => import('../views/app/repayment/plan.vue'),
			meta: {
				'title': ''
			}
		}
    ]
})

router.beforeEach((to, from, next) => {
	document.title = to.meta.title ? to.meta.title : 'OKash'
	next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js